/**
 * What the signed-in dashboard user may do. One function for one permission,
 * so a screen and the route guard of that screen ask the same question.
 *
 * The API decides for real. These only stop the dashboard from a call that
 * the API will refuse, and from a section that would then show wrong data.
 */

/**
 * May this user read and manage reviews? The API rule is the same
 * (`isAdminWithReviewPermission` in api/src/controllers/review.js): a super
 * admin, or an admin whose role has `manage_reviews`. A restaurant owner
 * (`role === "vendor"`) has neither.
 *
 * @param {{super_admin?: boolean, roles?: {manage_reviews?: boolean}}|null|undefined} adminInfo
 *   `state.auth.userData`
 * @returns {boolean}
 */
export const canManageReviews = (adminInfo) =>
    Boolean(adminInfo?.super_admin || adminInfo?.roles?.manage_reviews);
